import globalAxios from 'axios';
import { ref } from 'vue';

const isLoading = ref(false);
globalAxios.interceptors.request.use(
  async (config) => {
    isLoading.value = true;
    return config;
  },
  (error) => {
    isLoading.value = false;
    return Promise.reject(error);
  }
);
globalAxios.interceptors.response.use(
  (config) => {
    isLoading.value = false;
    return config;
  },
  (error) => {
    isLoading.value = false;
    return Promise.reject(error);
  }
);

export { isLoading };
